(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["service-tile"] && !Shopify.designMode) return;
  try {
    /* An in-page link (#…) in a modal closes it first, then scrolls, since the
     dialog's scroll lock would otherwise swallow the jump. */
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('.svc-modal a[href^="#"]');
    const component = link?.closest('dialog-component');
    if (!link || !component || link.hash.length < 2) return;

    const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
    if (!target) return;

    event.preventDefault();
    component.addEventListener('dialog:close', () => target.scrollIntoView({ behavior: 'smooth' }), {
      once: true,
    });
    component.closeDialog();
  });

  /* Theme editor: selecting a block inside a modal opens that modal, and
     moving the selection out of it closes it again. */
  if (window.Shopify?.designMode) {
    const modalOwner = (event) => {
      const block = event.target instanceof Element ? event.target : null;
      if (!block?.closest('.svc-modal')) return null;
      return block.closest('dialog-component');
    };

    let pendingClose;

    document.addEventListener('shopify:block:select', (event) => {
      const component = modalOwner(event);
      if (!component) return;

      clearTimeout(pendingClose);
      component.showDialog();
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      const component = modalOwner(event);
      if (!component) return;

      pendingClose = setTimeout(() => component.closeDialog(), 150);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
